// extracted by mini-css-extract-plugin
export default {"subCurationWrapper":"styles_subCurationWrapper__LTXka","subCurationItem":"styles_subCurationItem__Xs49J","title":"styles_title__39d5O","description":"styles_description__Q4i7l"};